import { createAction } from '@mews/framework';
import { PRICING_CLEARED, ORDER_VALUE_CHANGED } from './types';

export const clearPricing = (scope: $TSFixMe) => createAction(PRICING_CLEARED, undefined, { scope });

export const changeProductIdsWithoutPricingCheck = (value: $TSFixMe, scope: $TSFixMe) =>
    createAction(ORDER_VALUE_CHANGED, { key: 'productIds', value }, { scope });
